import axios from "axios";
import apiPath from "../constants/apiPath";

// Upload a file THROUGH the backend (POST /api/common/upload) so storage credentials
// never ship to the browser. Returns { Location, key } (Location = the stored URL),
// matching the shape the old direct-to-S3 code returned.
export const uploadViaBackend = async (file, dirName) => {
  const base = String(apiPath.baseURL || "").replace(/\/+$/, "");
  const token = localStorage.getItem("token");

  const form = new FormData();
  form.append("file", file);
  form.append("dirName", dirName || "admin/upload");

  // NOTE: do not set Content-Type manually — the browser adds the multipart boundary.
  const { data } = await axios.post(`${base}/common/upload`, form, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!data || data.status === false || !data.data || !data.data.Location) {
    throw new Error((data && data.message) || "Upload failed");
  }
  return { Location: data.data.Location, Key: data.data.key, key: data.data.key };
};
